import React from 'react';
import Text from 'components/Core/Text';
import { CustomerSelections, CustomerFilter } from './styles';
import { navigate } from 'gatsby';

const RegistrationOptions = ({ register, navigateToRegistration, ...otherProps }) => {
  return (
    <>
      <Text type="h5" size="25px">
        Which one are you?
      </Text>

      <CustomerFilter onClick={navigateToRegistration}>
        <Text className="pantheon-registration--selection" type="p" size="18px">
          I am a current customer of ServiceTitan
        </Text>
      </CustomerFilter>
      <CustomerFilter onClick={register}>
        <Text className="pantheon-registration--selection" type="p" size="18px">
          I am not a customer of ServiceTitan
        </Text>
      </CustomerFilter>
      <CustomerFilter onClick={navigateToRegistration}>
        <Text className="pantheon-registration--selection" type="p" size="18px">
          I am an invited guest
        </Text>
      </CustomerFilter>
    </>
  );
};

export default RegistrationOptions;
